import { Aura } from 'auragin'
import { filesystem } from '../init'

export type IDownloadType = 'modules' | 'layers' | 'basemap'

export interface IDownloadOnListenerProps {
  progress: number
}
export interface IStartZipDownloadProps {
  url: string
  filename: string
  directory?: string
  type: IDownloadType
  onListener?: (p: IDownloadOnListenerProps) => void
  metadata?: any
}

export default async function startZipDownload ({
  type,
  filename,
  url,
  onListener,
  directory,
  metadata
}: IStartZipDownloadProps): Promise<void> {
  return await new Promise(async (resolve, reject) => {
    if (filesystem === undefined) throw new Error('Filesystem not initialized.')

    const fullPath = directory !== undefined ? `${directory}/${filename}` : `${filesystem.getPath(type)}/${filename}`
    // DEFINE LISTENER FX
    const listener = (ev: any): void => {
      if (ev.detail.error !== undefined) {
        // saveDownloadInDevice({ url, status: 'error', description: ev.detail.error, type })
        console.error('Download error:', ev.detail.error)
        window.removeEventListener('downloader', listener)
        return reject(ev.detail.error)
      }

      if (onListener !== undefined) {
        onListener({
          progress: ev.detail.progress === 'completed' ? 100 : Number(ev.detail.progress)
        })
      }

      if (ev.detail.progress === 'completed') {
        // saveDownloadInDevice({ url, status: 'success', type })
        window.removeEventListener('downloader', listener)
        return resolve()
      }
    }

    window.addEventListener('downloader', listener)
    // await saveDownloadInDevice({ url, metadata, type })
    Aura.downloadZip({ fullPath, url, token: '' })
      .then(suc => {
        console.log('Download started:', suc)
      })
      .catch(err => {
        reject(err)
      })
  })
}
